import React from 'react'
import {Icon} from '@chakra-ui/react'

const FavouriteFilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <g clipPath="url(#clip0_3172_1393)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.54199 14.846C1.54199 9.20111 6.11806 4.625 11.7629 4.625C14.4737 4.625 17.0735 5.70189 18.9904 7.61872L20.0002 8.62867L21.0104 7.61855C22.9271 5.70182 25.5269 4.625 28.2376 4.625C33.8826 4.625 38.4585 9.20125 38.4585 14.8461C38.4585 17.5569 37.3816 20.1565 35.4649 22.0732L20.0002 37.538L4.53562 22.0734C2.61884 20.1565 1.54199 17.5567 1.54199 14.846Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_3172_1393">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="matrix(-1 0 0 1 40 0.000244141)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default FavouriteFilledIcon
